import {Label} from '@gravity-ui/uikit';
import {copyToClipboard, PropertyRow, useNotifications} from '../../../../shared';
import {Copy} from '@gravity-ui/icons';
import {FundraiserDetailedModel} from '../../model';
import styles from './DetailFundraiserInformation.module.scss';

interface DetailFundraiserInformationProps {
  fundraiserData: FundraiserDetailedModel | null;
}

export const DetailFundraiserInformation = ({fundraiserData}: DetailFundraiserInformationProps) => {
  const {createNotification} = useNotifications();
  const handleCopyId = async () => {
    if (fundraiserData?.id) {
      const success = await copyToClipboard(fundraiserData?.id);
      if (success) {
        createNotification({
          name: 'copy-id-success',
          title: 'ID сбора скопирован',
          theme: 'info',
        });
      } else {
        createNotification({
          name: 'copy-id-error',
          title: 'Ошибка при копировании ID сбора',
          theme: 'danger',
        });
      }
    }
  };
  return (
    <div className={styles.detailsContainer}>
      <PropertyRow property={'Название сбора'} value={fundraiserData?.name} />
      {fundraiserData?.shortName && (
        <PropertyRow property={'Короткое название сбора'} value={fundraiserData.shortName} />
      )}
      <PropertyRow property={'Номер сбора'} value={fundraiserData?.externalId || '—'} />
      <PropertyRow property={'ID сбора'} value={fundraiserData?.id} onclick={handleCopyId} icon={Copy} />
      {fundraiserData?.fund && (
        <PropertyRow
          property={'Фонд-партнёр'}
          value={<Label className={styles.label}>{fundraiserData.fund.name}</Label>}
        />
      )}
      {fundraiserData?.region && (
        <PropertyRow property={'Регион'} value={<Label className={styles.label}>{fundraiserData.region.name}</Label>} />
      )}
      {fundraiserData?.categories && (
        <PropertyRow
          property={'Категории'}
          value={fundraiserData.categories.map((category) => (
            <Label className={styles.label}>{category.name}</Label>
          ))}
        />
      )}
      {fundraiserData?.shortDescription && (
        <PropertyRow property={'Чем поможем'} value={fundraiserData.shortDescription} />
      )}
      {fundraiserData?.detailedDescription && (
        <PropertyRow property={'О сборе'} value={fundraiserData.detailedDescription} isHtml={true} />
      )}
    </div>
  );
};
